import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenefitHeaderSummaryComponent } from './benefit-header-summary/benefit-header-summary.component';
import { AvailableBudgetComponent } from './available-budget/available-budget.component';
import { ShowBenefitComponent } from './show-benefit/show-benefit.component';
import { ShowDiscountComponent } from './show-discount/show-discount.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { TranslateModule } from '@ngx-translate/core';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { CorePipesModule } from '../../../@core/pipes/pipes.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BenefitDetailsService } from 'app/core/service/benefit-details.service';
import { sanitizeHtmlPipe } from 'app/core/pipes/sanitize-html-pipe';
import { TaxCategoryDisplayComponent } from './tax-category-display/tax-category-display.component';
import { MobileCardPaymentComponent } from './mobile-card-payment/mobile-card-payment.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { CoreDirectivesModule } from '../../../@core/directives/directives';
import { RouterLinkWithHref } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ShowConsentComponent } from './show-consent/show-consent.component';
import { AccessibleImgPipe } from "../../core/pipes/accessible-img.pipe";
import { MealTicketSelectorComponent } from './meal-ticket-selector/meal-ticket-selector.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {NgSelectAriaControlDirective} from "../../core/directives/ng-select-aria-control.directive";
import { NotificationBannerComponent } from './notification-banner/notification-banner.component';
import { PensionContributionDialogComponent } from './pension-contribution-dialog/pension-contribution-dialog.component';
import { BudgetDetailsComponent } from './budget-details/budget-details.component';
import { OrdinalPipe } from '../../core/helpers/ordinal.pipe';
import { ErrorMessagesComponent } from './error-messages/error-messages.component';
import { RequiredConsentsComponent } from './required-consents/required-consents.component';
import { RequiredFieldsComponent } from './required-fields/required-fields.component';
import { AuthHeroImagePipe } from '../../core/pipes/auth-hero-image.pipe';
import { MaskedInputComponent } from '../../shared/masked-input/masked-input.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';


@NgModule({
  declarations: [
    BenefitHeaderSummaryComponent,
    AvailableBudgetComponent,
    ShowBenefitComponent,
    ShowDiscountComponent,
    PensionContributionDialogComponent,
    TermsOfServiceComponent,
    CookiePolicyComponent,
    PrivacyPolicyComponent,
    sanitizeHtmlPipe,
    AccessibleImgPipe,
    AuthHeroImagePipe,
    TaxCategoryDisplayComponent,
    MobileCardPaymentComponent,
    LanguageSelectorComponent,
    ShowConsentComponent,
    NotificationBannerComponent,
    MealTicketSelectorComponent,
    NgSelectAriaControlDirective,
    BudgetDetailsComponent,
    OrdinalPipe,
    ErrorMessagesComponent,
    RequiredConsentsComponent,
    RequiredFieldsComponent,
    MaskedInputComponent
  ],
  exports: [
    BenefitHeaderSummaryComponent,
    AvailableBudgetComponent,
    sanitizeHtmlPipe,
    AccessibleImgPipe,
    AuthHeroImagePipe,
    TaxCategoryDisplayComponent,
    MobileCardPaymentComponent,
    LanguageSelectorComponent,
    NotificationBannerComponent,
    MealTicketSelectorComponent,
    NgSelectAriaControlDirective,
    BudgetDetailsComponent,
    OrdinalPipe,
    ErrorMessagesComponent,
    RequiredConsentsComponent,
    RequiredFieldsComponent,
    MaskedInputComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    CorePipesModule,
    NgbModule,
    CoreDirectivesModule,
    RouterLinkWithHref,
    PdfViewerModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [BenefitDetailsService]
})
export class SharedModule {
  constructor(@Optional() @SkipSelf() parentModule: SharedModule) {}
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [BenefitDetailsService],
    };
  }
}
